import { api } from "./api";

export interface ReportLink {
  id: string;
  token: string;
  test_id: string;
  created_at: string;
  first_accessed_at: string | null;
  last_accessed_at: string | null;
  access_count: number;
  user_agent: string | null;
}

export async function resolveToken(token: string): Promise<ReportLink> {
  return api<ReportLink>(`/api/report-links/resolve/${token}`);
}
